<template>
  <vame @update="update">
    <renderer
      :scale="3"
      :pixel-scale="6"
      :clear-color="'#fff'"
    >
      <sprite
        :x="Math.floor(x)"
        :y="Math.floor(y)"
        :width="32"
        :height="32"
        src="logo.png"
      />
    </renderer>
  </vame>
</template>

<script>
import { components } from '@/vame.js'

export default {
  components: {
    ...components
  },

  data () {
    return {
      x: 160-16,
      y: 90-16
    }
  },

  methods: {
    update () {
      this.x = (Math.cos(performance.now()/1000) * 50) + (160-16)
      this.y = (Math.sin(performance.now()/1000) * 50) + (90-16)
    }
  }
}
</script>

<style lang="sass">
body
  background: #fafafa
</style>
